import { logout } from '../../repository/auth';
import router from './../../router';

const state = {
  token: null,
  refreshToken: null,
  snackBar: false,
  appErrors: [],
};

const getters = {
  token: store => store.token,
  refreshToken: store => store.refreshToken,
  snackBar: store => store.snackBar,
  appErrors: store => store.appErrors,
};

const mutations = {
  SET_TOKENS(state, tokens) {
    const { token, refresh } = tokens;
    state.token = token;
    state.refreshToken = refresh;
  },
  CLEAR_TOKENS(state) {
    state.token = null;
    state.refreshToken = null;
  },
  SET_SNACKBAR(state, data) {
    state.snackBar = data;
  },
  SET_ERRORS(state, err) {
    if (!state.appErrors.includes(err)) {
      state.appErrors.push(err);
    }
  },
  CLEAR_ERRORS(state) {
    state.appErrors = [];
  },
  REMOVE_ERROR(state, index) {
    state.appErrors.splice(index, 1);
  },
};

const actions = {
  setTokens({ commit }, tokens) {
    commit('SET_TOKENS', tokens);
  },
  setSnackBar({ commit }, data) {
    commit('SET_SNACKBAR', data);
  },
  setError({ commit }, err) {
    commit('SET_ERRORS', err);
  },
  clearErrors({ commit }) {
    commit('CLEAR_ERRORS');
  },
  clearError({ commit }, index) {
    commit('REMOVE_ERROR', index);
  },
  clearUserData({ dispatch, commit }) {
    dispatch('user/setUser', null, { root: true });
    dispatch('user/setNeedPassword', false, { root: true });
    commit('CLEAR_TOKENS');
    router.push('/login');
  },
  pageNotFound() {
    router.push('/error404');
  },
  async logoutUser({ dispatch }) {
    logout();
    dispatch('clearUserData');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
